<!--
 * @创建文件时间: 2019-12-25 15:18:28
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-24 00:28:50
 * @联系Qq:1638245306
 * @文件介绍: 自定义head菜单组件
 -->
<template>
   <el-header  style="height:40px;line-height:40px;width: 100%;min-width: 1360px;">
        <el-row>
        <el-col :span="1">
         <div class="toggle-aside-btn"
           @click="handleToggleAside" 
           style="display:inline-block;padding-left:10px;cursor: pointer;">
             <d2-icon style="color:white" name="bars"/>
           </div>
      </el-col>
      <el-col :span="23" style="text-align: justify;justify-content: space-between;">    
        <!-- display: flex; -->
          <!-- <div class="ui-box is-link" :class="{active:'10086'===isActive}"  style="display:inline-block;padding:0px 5px;cursor: pointer;font-size:16px;"    @click="toGisMap">
           <d2-icon name="cog"/>&nbsp; 全省公路系统综合监管平台
          </div> -->
          <div
          v-for="(item,index) in menu" :key="index" 
          style="display:inline-block;padding:0px 5px;cursor: pointer;font-size:16px;margin-right: 50px;"
          class="ui-box is-link"
          :class="{active:index===isActive}"
            @click="getSideMenu(item.id,index)"
          >
            <d2-icon :name="item.icon"/>&nbsp; {{item.title}}
          </div>
           
      </el-col>
    </el-row>
   </el-header>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import util from '@/libs/util.js'
import globalEvent from "@/components/GlobalEvent";
export default {
  name:"",
  components: {},
  props: {},
  data() {
    return {
         menu:[],
         userId:'',
         isActive:'',
    };
  },
  watch: {},
  computed: {},
  methods: {
      ...mapActions('d2admin/menu', [
      'asideCollapseToggle'
    ]),
    /**
     * 接收点击切换侧边栏的按钮 
     */
    handleToggleAside () {
      this.asideCollapseToggle()
    },
    //获取头部菜单
    getHeaderMenu(){
        var storage = window.sessionStorage;  
        let menuUrl= storage.getItem("menuUrl");
        this.$store.dispatch('d2admin/user/load').then(data=>{ 
            this.userId = data.userId
             this.$http.post(this.$url.gettopmenus,{
                userId:data.userId,
                menuCate:menuUrl,
             }).then(res=>{
                this.menu = res.data;
             })
        })
    },
    //跳转到gis
    toGisMap(){
      this.isActive='10086'
      this.$router.push("index")
    },
    //获取侧边栏
    getSideMenu(id,key){
        this.isActive = key
        this.$http.post(this.$url.getHeadMenu,{
    		userId:this.userId ,
            menuType: '1',
            menuId:id
    		}).then(res=>{
    			let menu = res.data
            this.$store.commit('d2admin/menu/asideSet', menu)
            this.setMenu(menu)
            globalEvent.menuRerander()
        })
        this.$store.dispatch('d2admin/menu/asideCollapseSet', false)
    },
    //设置菜单缓存
		async setMenu (data) {
			const db = await this.$store.dispatch('d2admin/db/database')
            db.set('menu', data).write()
    },
  },
  created() {
    //  this.$store.commit('d2admin/menu/asideSet', [])
     this.getHeaderMenu()
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>

.is-link{
  color: #ffffff;
  background: transparent;
}
.is-link:hover{
    color: yellow;
    // background: rgba(255, 255, 255, 0.5)
}

   .ui-box {
    text-decoration:none;
    border:none;
    font-family:'Roboto', sans-serif;
    font-size:14px;
    position: relative;
    vertical-align:baseline;
    padding:10px
}
.is-link:before,.is-link:after,.is-link>.ui-border-element:before,.is-link>.ui-border-element:after {
    content:'';
    position: absolute;
    bottom:0%;
    border: none;
}
.is-link:after {
    border-bottom:1px solid yellow;
    left:51%;
    right:51%;
    bottom:0px;
    -webkit-transition-property:all;
    -moz-transition-property:all;
    -o-transition-property:all;
    transition-property:all;
    -webkit-transition-timing-function:cubic-bezier(0, 0.98, 0.51, 0.93);
    -moz-transition-timing-function:cubic-bezier(0, 0.98, 0.51, 0.93);
    -o-transition-timing-function:cubic-bezier(0, 0.98, 0.51, 0.93);
    transition-timing-function:cubic-bezier(0, 0.98, 0.51, 0.93);
    -webkit-transition-duration:500ms;
    -moz-transition-duration:500ms;
    -o-transition-duration:500ms;
    transition-duration:500ms;
    -webkit-transition-delay:0s;
    -moz-transition-delay:0s;
    -o-transition-delay:0s;
    transition-delay:0s
}
.is-link:hover:after {
    left:0%;
    right:0%
}
.is-link:not(:hover):after {
    -webkit-transition-delay:0s;
    -moz-transition-delay:0s;
    -o-transition-delay:0s;
    transition-delay:0s;
    border:none;
}
.active{
    color: yellow;
    fill: yellow;
    border-bottom: 2px solid yellow;
}

</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/menu-header/headerMenu.vue"
}
</vue-filename-injector>
